<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    @close="handleClose"
    width="560px"
    class="rc-dialog"
  >
    <el-form
      ref="curdForm"
      :model="curdForm"
      size="small"
      :rules="rules"
      label-position="right"
      label-width="100px"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="期刊年份："
            class="full"
            prop="periodicalYear"
            required
          >
            <el-date-picker
              type="year"
              placeholder="选择年份"
              v-model="curdForm.periodicalYear"
              format="yyyy"
              value-format="yyyy"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="期刊期次：" prop="currentPeriod" required>
            <el-input
              v-model="curdForm.currentPeriod"
              placeholder="请输入期刊期次"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="总期次：" prop="totalPeriod">
            <el-input
              v-model="curdForm.totalPeriod"
              placeholder="请输入总期次"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="出版日期：" class="full" prop="publishDate">
            <el-date-picker
              type="date"
              placeholder="选择出版日期"
              v-model="curdForm.publishDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" btntype title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "../Bus";
import rulesFactory from "@/utils/rules";
import {
  periodicalPeriodInfo,
  periodicalPeriodSave,
  periodicalPeriodUpdate
} from "@/api/periodicalPeriod";
import { getNextPeriod } from "@/api/periodicalInfo";

export default {
  name: "curd",
  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      curdForm: {},
      rules: {
        periodicalYear: [rulesFactory.required("请选择期刊年份")],
        currentPeriod: [
          rulesFactory.required("请输入期刊期次"),
          { validator: this.validateNumber }
        ],
        totalPeriod: [{ validator: this.validateTotal }]
      }
    };
  },
  created() {
    Bus.$on("savePeriod", periodicalId => {
      this.curdForm.periodicalId = periodicalId;
      this.nextPeriod(periodicalId);
      this.showFrom("新增期次");
    });
    Bus.$on("updatePeriod", item => {
      this.info(item.uuid);
      this.showFrom("编辑期次");
    });
  },
  methods: {
    validateNumber(rule, value, callback) {
      //1-500整数
      if (!value || new RegExp(/^(?:[1-9]\d?|[1-4]\d{2}|500)$/).test(value)) {
        callback();
      } else {
        callback("请输入1-500的整数");
      }
    },
    validateTotal(rule, value, callback) {
      if (!value || new RegExp(/^(\+?[1-9]\d{0,2}|\+?1000)$/).test(value)) {
        callback();
      } else {
        callback("请输入1-1000的整数");
      }
    },
    handleClose() {
      this.$refs["curdForm"].resetFields();
      this.curdForm = {};
      this.isShow = false;
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    nextPeriod(periodicalId) {
      //默认 年份 期次 总期次
      getNextPeriod(periodicalId).then(res => {
        if (res && res.code == 0) {
          this.$set(this.curdForm, "periodicalYear", res.data.year + "");
          this.$set(this.curdForm, "currentPeriod", res.data.nextPeriod);
          this.$set(this.curdForm, "totalPeriod", res.data.nextTotalPeriod);
        }
      });
    },
    info(uuid) {
      periodicalPeriodInfo(uuid).then(res => {
        if (res && res.code == 0) {
          this.curdForm = res.data;
        }
      });
    },
    submitForm() {
      this.$refs["curdForm"].validate(valid => {
        if (valid) {
          //this.curdForm.uuid = this.curdForm.id || "";
          const params = Object.assign({}, this.curdForm);
          if (!this.curdForm.uuid) {
            // 新增
            periodicalPeriodSave(params).then(res => {
              if (!res || res.code != 0) throw new Error(res.msg);
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                //重新加载
                Bus.$emit("reload2");
                this.handleClose();
              }
            });
          } else {
            //编辑
            periodicalPeriodUpdate(params).then(res => {
              if (!res || res.code != 0) throw new Error(res.msg);
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                //重新加载
                Bus.$emit("reload2");
                this.handleClose();
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
